<div class="shared-data-sets maximized-component">
    <div class="header-bar" [attr.data-automation-id]="automationId + '-header-container'">
        <span>Shared Data Sets</span>
        <button type="button" class="help-button" [attr.data-automation-id]="automationId + '-help-button'"
            (click)="openHelp()">
            <i class="fa fa-question"></i>
        </button>
    </div>
    <div class="grids-container">
        <div id="sharedDataSets">
            <res-generic-grid [gridName]="gridName" [automationId]="automationId" [updateStatusType]="updateStatusType"
                [isBusyOnInit]="true" [pagerVisible]="false" [contextMenuOptions]="contextMenuOptions"
                [columnDefs]="columnDefs" [rowSelection]="rowSelection" [requestInfo]="requestInfo"
                [gridContext]="gridContext" [responseArrayCallback]="responseArrayCallback"
                [onSelectionChanged]="onSelectionChanged">
            </res-generic-grid>
        </div>
        <res-resizer [attr.data-automation-id]="automationId + '-resizer-button'" anchor="left"
            resizingElementId="sharedDataSets" secondElementId="sharedDataSetInfo" [usePercentages]="true"
            [initSize]="60" [minSize]="20" [maxSize]="80" [ellipsisExpander]="true"></res-resizer>
        <div id="sharedDataSetInfo">
            <res-generic-grid [automationId]="automationIdDataSetProjects" [pagerVisible]="false"
                [columnDefs]="columnDefsDataSetProjects">
            </res-generic-grid>
            <div class="no-selection" *ngIf="!selectedCorpus"><span>Please select a Data Set</span></div>
        </div>
    </div>
</div>